/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Assignment_Email_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Could not send email: {error}" |
*
* @param {Explorer_Assignment_Email_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_assignment_email_failed_toast = /** @type {((inputs: Explorer_Assignment_Email_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Assignment_Email_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible d'envoyer l'e-mail : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`E-Mail konnte nicht gesendet werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile inviare l'email: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось отправить письмо: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo enviar el correo: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法发送邮件：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`メールを送信できませんでした: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ईमेल नहीं भेजा जा सका: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível enviar o e-mail: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Could not send email: ${i?.error}`)
});